import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from '@gelirgider/i18n';
import tr from '@gelirgider/i18n/messages/tr';
import en from '@gelirgider/i18n/messages/en';
import de from '@gelirgider/i18n/messages/de';
import fr from '@gelirgider/i18n/messages/fr';
import nl from '@gelirgider/i18n/messages/nl';
import adminTr from '@gelirgider/i18n/messages/admin/tr';
import adminEn from '@gelirgider/i18n/messages/admin/en';
import adminDe from '@gelirgider/i18n/messages/admin/de';
import adminFr from '@gelirgider/i18n/messages/admin/fr';
import adminNl from '@gelirgider/i18n/messages/admin/nl';

const resources = {
  tr: { translation: tr, admin: adminTr },
  en: { translation: en, admin: adminEn },
  de: { translation: de, admin: adminDe },
  fr: { translation: fr, admin: adminFr },
  nl: { translation: nl, admin: adminNl },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    ns: ['translation', 'admin'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'gelirgider-admin-locale',
    },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (lngs, ns, key) => {
          console.warn(`[i18n] missing key: ${ns}:${key} (lang: ${lngs.join(',')})`);
        }
      : undefined,
  });

export const ADMIN_SUPPORTED_LOCALES = ['tr', 'en', 'de', 'fr', 'nl'] as const;
export type AdminLocale = (typeof ADMIN_SUPPORTED_LOCALES)[number];

export default i18n;
